import React from 'react'

const ReceivedTransactionItem = () => {
  return (
    <div>ReceivedTransactionItem</div>
  )
}

export default ReceivedTransactionItem